import { getOrders, IOrder } from 'API';
import { useAppSelector } from 'Hooks';
import { createContext, FC, useEffect, useState } from 'react';

export type ORDER_STATUS = 'FINISHED' | 'STARTED' | 'IN_PROGRESS' | 'FAILED';

interface IOrderContext {
  orders: IOrder[];
  loadAllOrders: () => Promise<void>;
  isAllLoaded: boolean;
  STATUS: ORDER_STATUS;
  addOrder: (order: IOrder) => void;
}
export const OrdersContext = createContext<IOrderContext>({
  orders: [],
  loadAllOrders: () => {
    return new Promise((resolve) => {
      resolve();
    });
  },
  isAllLoaded: false,
  STATUS: 'STARTED',
  addOrder: () => {},
});

export const OrdersProvider: FC<{}> = (props) => {
  const [orders, setOrders] = useState<IOrder[]>([]);
  const [isAllLoaded, setIsAllLoaded] = useState<boolean>(false);
  const [ordersStatus, setOrderStatus] = useState<ORDER_STATUS>('STARTED');

  const initOrders = async (pageSize?: number, pageNumber?: number) => {
    setOrderStatus('IN_PROGRESS');
    const orders = await getOrders(pageSize, pageNumber);
    if (orders) {
      setOrders(orders);
      setOrderStatus('FINISHED');
    } else {
      setOrderStatus('FAILED');
    }
  };

  const loadAllOrders = async () => {
    if (isAllLoaded) return;
    await initOrders();
    setIsAllLoaded(true);
  };

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  useEffect(() => {
    initOrders(5, 1);
  }, [imposterId]);

  const addOrder = (order: IOrder) => {
    setOrders([order, ...orders]);
  };

  return (
    <OrdersContext.Provider
      value={{
        orders,
        loadAllOrders,
        isAllLoaded,
        STATUS: ordersStatus,
        addOrder,
      }}
    >
      {props.children}
    </OrdersContext.Provider>
  );
};
